<div class="or-px-16-px or-pb-16-px">
  @for (item of faqContent(); track item.id) {
    <div (click)="changeVisibility(item)" class="faq-item or-bg-white border-radius-4 or-px-16-px or-mt-12-px">
      <div class="faq-item__title or-d-flex or-align-items-center or-justify-content-between">
        <div class="or-head-xs">{{ item.title }}</div>
        <img
          [src]="item.isVisible ? 'assets/icons/chevron-up.svg' : 'assets/icons/chevron-down-primary.svg'"
          class="or-ml-8-px" />
      </div>

      @if (item.isVisible) {
        <div class="or-note-sm or-color-secondary-2 or-pb-16-px">
          <div>{{ item.content }}</div>
          @if (item.listItems) {
            <div class="or-mt-8-px or-px-12-px">
              @for (listItem of item.listItems; track listItem) {
                <li>{{ listItem }}</li>
              }
            </div>
          }
          @if (item.contentAfterList) {
            <div class="or-mt-8-px">{{ item.contentAfterList }}</div>
          }
        </div>
      }
    </div>
  }
</div>
